import {termsHostLayout, termsHostRedirect} from '~/composables/useTermsHost';

/*
 * terms.tapleagues.com: the legal pages without the site's chrome, and the bare
 * host opens on the terms. Set here rather than in the page because a layout
 * chosen on the server has to be settled before Vue renders, or it hydrates
 * with the wrong one.
 */
export default defineNuxtRouteMiddleware((to) => {
    const hostname = useRequestURL().hostname;

    const redirect = termsHostRedirect(hostname, to.path);
    if (redirect) {
        return navigateTo(redirect, {replace: true});
    }

    const layout = termsHostLayout(hostname, to.path);
    if (layout) {
        setPageLayout(layout);
    }
});
